import { useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import InvitationAcceptCard from "../features/organization/components/InvitationAcceptCard";

/**
 * Public landing page for organization invitation links (/invitation?token=…).
 * Works signed-out: shows the invitation preview and routes the visitor
 * through sign-up / sign-in before accepting.
 */
const InvitationAcceptPage = () => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");

  return (
    <section>
      <div className="mx-auto w-full max-w-xl p-4 py-10 lg:py-16">
        <h1>{t("organization.invitationPage.title", "Organization invitation")}</h1>
        <div className="with-border mt-4 rounded-2xl p-4 lg:mt-6 lg:p-6">
          {token ? (
            <InvitationAcceptCard token={token} />
          ) : (
            <div>
              <p className="font-medium text-grey-20 dark:text-white">
                {t("organization.invitationPage.incompleteTitle", "This invitation link is incomplete.")}
              </p>
              <p className="mt-2 text-sm text-grey-30 dark:text-grey-70">
                {t("organization.invitationPage.incompleteHint", "Open the link from your invitation email, or ask the organization's owner to send a new one.")}
              </p>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default InvitationAcceptPage;
